<template>
  <div class="boutons">
      <simple-bouton text="Activite" destination="/Professeur/Activite"/>
      <simple-bouton text="Gestion" destination="/Professeur/Gestion"/>
  </div>
</template>

<script>
import SimpleBouton from '../../Bouton.vue'


export default {
    components: {
        SimpleBouton
    },
    
}
</script>

<style scoped>
    .boutons{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 29rem;
    }


</style>